// The Enterprise question's green framework badge. OrganizationQuestions.QuestionFramework only names
// frameworks ("PISF 2026 | Sector-Specific Framework"), and PISF 2026 has no control column — its PKCERT
// controls come from the backend crosswalk as pisfControls. Attach them to the PISF name so the badge
// shows which controls the question evidences; any other label is returned unchanged.
export function withPisfControls(label, pisfControls) {
  if (!label || !Array.isArray(pisfControls) || pisfControls.length === 0) return label;
  return label.replace(/PISF 2026/i, (name) => `${name}: ${pisfControls.join(", ")}`);
}

// Framework names the question banks prefix control ids with ("SOC 2 CC5.2, CC6.1"), longest first
// so "FedRAMP / NIST 800-53 Rev 5 AC-2" keeps its whole name rather than stopping at a shorter one.
const FRAMEWORK_NAMES = [
  "FedRAMP / NIST 800-53 Rev 5", "FedRAMP / 800-53", "NIST CSF 2.0", "NIST 800-171",
  "ISO 27001:2022", "CIS Controls v8", "PCI DSS v4", "HITRUST CSF", "SBP Framework", "PISF 2026",
  "NERC CIP", "CMMC L2", "SOC 2", "HIPAA", "GDPR", "DORA", "PECA", "GLBA", "SOX",
];

// The Ransomware and TPRM vertical questions list each framework with its controls
// ("SOC 2 CC5.2, CC6.1; NIST CSF 2.0 GV.OC-01; PISF 2026"), which turns the green badge into a
// paragraph while every other question names frameworks only. Keep just the names: a "; " entry
// that starts with a known framework name followed by a control id (anything with a digit) is cut
// back to the name; any other entry ("NIST SP 800-53 Rev.5", "State Money Transmitter Laws") is
// left as written. The controls themselves stay on the question and in the risk's framework cards.
export function frameworkNamesOnly(label) {
  if (!label) return label;
  const names = [];
  for (const raw of label.split(";")) {
    const entry = raw.trim();
    if (!entry) continue;
    const name = FRAMEWORK_NAMES.find((n) => {
      if (!entry.toLowerCase().startsWith(n.toLowerCase())) return false;
      const rest = entry.slice(n.length);
      return rest === "" || (/^\s/.test(rest) && /\d/.test(rest));
    });
    const shown = name ?? entry;
    if (!names.some((n) => n.toLowerCase() === shown.toLowerCase())) names.push(shown);
  }
  return names.join("; ");
}
